/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespComplementaryItemsGrid_user$ref: FragmentReference;
export type PdpRespComplementaryItemsGrid_user = {|
  +serviceId: ?string,
  +$fragmentRefs: PdpRespSimilarItem_user$ref,
  +$refType: PdpRespComplementaryItemsGrid_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespComplementaryItemsGrid_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ee3e5955eb96313f940b13f49e4296ec';
module.exports = node;
